const OprHistoryStatistics = () =>
  import('@/views/main/helper/oprHistoryStatistics/OprHistoryStatistics.vue')
export default {
  path: '/main/helper/oprHistoryStatistics',
  name: 'OprHistoryStatistics',
  component: OprHistoryStatistics,
  children: []
}
